import { render, staticRenderFns } from "./pickUpByTensionBeatsModal.vue?vue&type=template&id=149540b2"
import script from "./pickUpByTensionBeatsModal.vue?vue&type=script&lang=js"
export * from "./pickUpByTensionBeatsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports